/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useEffect, useMemo, useState } from "react"
import {
  Combobox,
  // ComboboxProps as MantineComboboxProps,
  useCombobox,
  CloseButton,
} from "@mantine/core"
import clx from "classnames"
import { Autocomplete as MUIAutocomplete } from "@mui/material"

import styles from "./Autocomplete.mantine.module.scss"

export const MUIMappedAutocomplete = (
  props: React.ComponentProps<typeof MUIAutocomplete>,
) => {
  const anyProps = props as any
  const {
    id,
    className,
    classes,
    multiple,
    onChange,
    options,
    value: parentValue,
    disableCloseOnSelect,
    disableClearable,
    getOptionLabel,
    renderOption,
    renderInput,
    ChipProps,
  } = props
  const [value, setValue] = useState<
    string | object | string[] | object[] | null
  >((parentValue as any) ?? props.defaultValue ?? (multiple ? ["a"] : ""))
  const [inputValue, setInputValue] = useState("")
  const [opened, setOpened] = useState(false)
  const inputRef = React.useRef<HTMLInputElement>(null)
  const [shouldFilter, setShouldFilter] = useState(false)

  useEffect(() => {
    if (!multiple && parentValue) {
      setValue(parentValue as any)
    }
  }, [multiple, parentValue])

  const filteredOptions = useMemo(
    () =>
      shouldFilter
        ? options.filter((item) =>
            typeof item === "string"
              ? item.toLowerCase().includes(inputValue.trim().toLowerCase())
              : getOptionLabel?.(item)
                  .toLowerCase()
                  .includes(inputValue.trim().toLowerCase()),
          )
        : options,
    [getOptionLabel, inputValue, options, shouldFilter],
  )

  const combobox = useCombobox({
    opened,
    onOpenedChange(o) {
      setOpened(o)
    },
  })

  // MULTIPLE
  const multiCombobox = useCombobox({
    opened,
    onDropdownClose: () => multiCombobox.resetSelectedOption(),
    onDropdownOpen: () => multiCombobox.updateSelectedOptionIndex("active"),
  })

  const handleValueSelect = (val: string) => {
    const newValue = (
      (value as string[]).includes(val)
        ? (value as string[]).filter((v) => v !== val)
        : [...(value as string[]), val]
    ) as any
    setValue(newValue)
    return newValue
  }

  const handleValueRemove = (val: string) => {
    setValue((current) => (current as string[]).filter((v) => v !== val) as any)
  }

  const handleValueClear = () => setValue([] as any)

  if (multiple) {
    return (
      <Combobox
        store={multiCombobox}
        onOptionSubmit={(option) => {
          setShouldFilter(false)
          const newValue = handleValueSelect(option)
          setInputValue("")
          !disableCloseOnSelect && setOpened(false)
          if (onChange) {
            onChange(undefined as any, newValue, "selectOption")
          }
        }}
        data-testid={anyProps?.["data-testid"] ?? ""}
      >
        <Combobox.DropdownTarget>
          {renderInput
            ? renderInput({
                id: id ?? "",
                inputProps: {
                  ref: inputRef,
                  onChange: (e: any) => {
                    setShouldFilter(true)
                    setInputValue(e.target.value)
                  },
                  value: inputValue,
                  onClick: () => setOpened(true),
                  onBlur: () => {
                    setOpened(false)
                    setShouldFilter(false)
                  },
                  onFocus: () => {
                    setOpened(true)
                    setShouldFilter(false)
                  },
                  onKeyDown: (e: any) => {
                    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                      e.preventDefault()
                      if (!opened) {
                        multiCombobox.openDropdown()
                        multiCombobox.selectActiveOption()
                      } else {
                        e.key === "ArrowDown"
                          ? multiCombobox.selectNextOption()
                          : multiCombobox.selectPreviousOption()
                      }
                    }
                    if (e.key === "Enter") {
                      e.preventDefault()
                      multiCombobox.clickSelectedOption()
                    }
                    if (e.key === "Backspace" && !inputValue) {
                      e.preventDefault()
                      handleValueRemove(
                        (value as string[])[(value as string[]).length - 1],
                      )
                    }
                  },
                  className: clx(styles.fullWidth, className),
                },
                disabled: props.disabled ?? false,
                fullWidth: props.fullWidth ?? false,
                size: "medium" as any,
                InputLabelProps: {},
                chips: {
                  values: (value as any[]).map((v) => ({
                    value: v,
                    onRemove: () => handleValueRemove(v),
                  })),
                  onRemove: handleValueRemove,
                  chipProps: ChipProps,
                },
                InputProps: {
                  className: "",
                  endAdornment: (
                    <div className={clx(styles.adornmentRight)}>
                      {disableClearable || !inputValue || !value ? null : (
                        <CloseButton
                          onClick={() => {
                            handleValueClear()
                            setInputValue("")
                          }}
                        />
                      )}
                      <Combobox.Chevron className={clx(styles.chevron)} />
                    </div>
                  ),
                  startAdornment: null,
                  ref: inputRef,
                },
              } as any)
            : null}
        </Combobox.DropdownTarget>

        <Combobox.Dropdown>
          <Combobox.Options>
            {filteredOptions.map((option, index) => (
              <Combobox.Option
                key={index}
                className={clx(
                  (value as string[]).includes(option as string) &&
                    styles["option-selected"],
                  styles.option,
                )}
                value={option as string}
              >
                {/* @ts-ignore */}
                {renderOption
                  ? renderOption(
                      // @ts-ignore
                      {},
                      option,
                      {
                        index,
                        selected: Array.isArray(value)
                          ? (value as string[]).includes(option as string)
                          : value === option,
                        inputValue,
                      },
                      props as any,
                    )
                  : option}
              </Combobox.Option>
            ))}
          </Combobox.Options>
        </Combobox.Dropdown>
      </Combobox>
    )
  }

  return (
    <Combobox
      store={combobox}
      onOptionSubmit={(option) => {
        setShouldFilter(false)
        setValue(option as any)
        setInputValue(option as any)
        !disableCloseOnSelect && setOpened(false)
        if (onChange) {
          onChange(undefined as any, option as any, "selectOption")
        }
      }}
      classNames={{
        dropdown: classes?.listbox,
        empty: classes?.noOptions,
        option: classes?.option,
        options: classes?.listbox,
        group: classes?.groupUl,
        groupLabel: classes?.groupLabel,
        search: classes?.input,
      }}
      data-testid={anyProps?.["data-testid"] ?? ""}
    >
      <Combobox.Target>
        {renderInput
          ? renderInput({
              id: id ?? "",
              inputProps: {
                ref: inputRef,
                onChange: (e) => {
                  setShouldFilter(true)
                  setInputValue(e.target.value)
                },
                value: inputValue,
                onClick: () => setOpened(true),
                onBlur: () => {
                  setOpened(false)
                  setShouldFilter(false)
                },
                onFocus: () => {
                  setOpened(true)
                  setShouldFilter(false)
                },
                onKeyDown: (e) => {
                  if (e.key === "ArrowDown" || e.key === "ArrowUp") {
                    e.preventDefault()
                    if (!opened) {
                      combobox.openDropdown()
                      combobox.selectActiveOption()
                    } else {
                      e.key === "ArrowDown"
                        ? combobox.selectNextOption()
                        : combobox.selectPreviousOption()
                    }
                  }
                  if (e.key === "Enter") {
                    e.preventDefault()
                    combobox.clickSelectedOption()
                  }
                },
                className: clx(styles.fullWidth, className),
              },
              disabled: props.disabled ?? false,
              fullWidth: props.fullWidth ?? false,
              size: "medium" as any,
              InputLabelProps: {},
              InputProps: {
                className: "",
                endAdornment: (
                  <div className={clx(styles.adornmentRight)}>
                    {disableClearable || !inputValue || !value ? null : (
                      <CloseButton
                        onClick={() => {
                          setValue(null)
                          setInputValue("")
                        }}
                      />
                    )}
                    <Combobox.Chevron className={clx(styles.chevron)} />
                  </div>
                ),
                startAdornment: null,
                ref: inputRef,
              },
            })
          : null}
      </Combobox.Target>
      <Combobox.Dropdown>
        <Combobox.Options>
          {filteredOptions.map((option, index) => (
            <Combobox.Option
              key={index}
              onClick={(e) => {
                if (!renderOption) {
                  setShouldFilter(false)
                  setValue(option as any)
                  setInputValue(option as any)
                  !disableCloseOnSelect && setOpened(false)
                  if (onChange) {
                    onChange(e, option as any, "selectOption")
                  }
                }
              }}
              className={clx(
                option === value && styles["option-selected"],
                styles.option,
              )}
              value={option as string}
            >
              {/* @ts-ignore */}
              {renderOption
                ? renderOption(
                    // @ts-ignore
                    {
                      onClick: (e) => {
                        setShouldFilter(false)
                        setValue(option as any)
                        setInputValue(option as any)
                        setOpened(false)
                        if (onChange) {
                          onChange(e, option as any, "selectOption")
                        }
                      },
                    },
                    option,
                    {
                      index,
                      selected: Array.isArray(value)
                        ? (value as string[]).includes(option as string)
                        : value === option,
                      inputValue,
                    },
                    props as any,
                  )
                : option}
            </Combobox.Option>
          ))}
        </Combobox.Options>
      </Combobox.Dropdown>
    </Combobox>
  )
}

export default MUIMappedAutocomplete
